module.exports = __webpack_public_path__ + "assets/img/88_519_4.dd94c1ad.jpg";